import { getDB } from '@office-start/idb-cache';
import { deleteDB } from 'idb';
import { dbStoreName, lastSyncTimestampKeySuffix, lastUiSyncTimestampKeySuffix, storageKeyPrefix, } from '../models/Constants';
export function getEdgeworthDb(dbName, dbVersion, workload, puid, onBlocking, disableDbAccess) {
    var clearSyncTimestamps = function () {
        var oldKeys = [];
        for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key &&
                (key.indexOf("".concat(storageKeyPrefix).concat(lastSyncTimestampKeySuffix)) >= 0 ||
                    key.indexOf("".concat(storageKeyPrefix).concat(lastUiSyncTimestampKeySuffix)) >= 0 ||
                    key.indexOf("".concat(storageKeyPrefix).concat(workload).concat(lastSyncTimestampKeySuffix)) >= 0 ||
                    key.indexOf("".concat(storageKeyPrefix).concat(workload).concat(lastUiSyncTimestampKeySuffix)) >= 0)) {
                oldKeys.push(key);
            }
        }
        if (oldKeys.length) {
            oldKeys.forEach(function (key) { return localStorage.removeItem(key); });
        }
    };
    var innerGetDb = function () {
        return getDB(dbName, {
            upgrade: function (upgradeDb) {
                try {
                    upgradeDb.deleteObjectStore(dbStoreName);
                    // Legacy Database Name didn't include workload, we need to delete those tables from the browser to save space.
                    var oldDbName = "edgeworth-".concat(puid);
                    indexedDB.deleteDatabase(oldDbName);
                }
                catch (_a) {
                    /* Do nothing. */
                }
                var store = upgradeDb.createObjectStore(dbStoreName);
                store.createIndex('useractions_date', 'useractions_datetime');
                store.createIndex('useractions_date_desc', 'useractions_datetime_inverse_time_in_ms');
                clearSyncTimestamps();
            },
            blocking: function () {
                // This callback fires when a new tab or window tries to open a newer version of the database,
                // but old versions in an existing tab are preventing upgrading of the database.
                // To workaround this, when a connection is blocking, we close the connection, and prevent
                // opening of any future connections.
                dbPromise === null || dbPromise === void 0 ? void 0 : dbPromise.then(function (db) { return db.close(); });
                if (disableDbAccess) {
                    disableDbAccess();
                }
                if (onBlocking) {
                    onBlocking();
                }
            },
        }, dbVersion);
    };
    var dbPromise = innerGetDb().catch(function (e) {
        // Getting the database in Chromium browsers when there isn't enough storage will throw a connection closing exception.
        // See bug: https://bugs.chromium.org/p/chromium/issues/detail?id=146284
        // In Firefox 51-54, in Incognito, there is no way to open or modify an IndexedDB table, as it throws InvalidStateError.
        if ((e === null || e === void 0 ? void 0 : e.name) === 'InvalidStateError') {
            if (disableDbAccess) {
                disableDbAccess();
            }
        }
        else if (e instanceof DOMException && e.name === 'VersionError') {
            // If requested version is less than the current DB version, browser throws DOMException, so we should delete current DB
            // and retry getDB operation. This can happen when we bump DB version but decided to roll back the build. In Chrome 48+/Firefox 58+,
            // DOMException gets returned instead of DOMError, and DOMError doesn't seem to have a specific error for this scenario
            // References: https://developer.mozilla.org/en-US/docs/Web/API/IDBRequest/error
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
            // Also clear sync timestamp to ensure we do full delta sync request later
            clearSyncTimestamps();
            return deleteDB(dbName).then(innerGetDb);
        }
        throw e;
    });
    return dbPromise;
}
//# sourceMappingURL=getEdgeworthDb.js.map